import React from 'react'
import PropTypes from 'prop-types'
import Step from '../../../components/Step'
import Select from 'react-select'
import _ from 'lodash'
import PROPTYPES from '../../../lib/propTypes'
import './SiteTools.scss'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import { BeatLoader } from 'react-spinners'

import "react-datepicker/dist/react-datepicker.css"

const gapi = window.gapi

var CLIENT_ID = '457995363627-nrrpgoqilmr6d514b7073l8c9kqnf9e0.apps.googleusercontent.com'
var API_KEY = '1C8n200ID_C_d0sMx1rMAjh2'

// Array of API discovery doc URLs for APIs used by the quickstart
var DISCOVERY_DOCS = ['https://docs.googleapis.com/$discovery/rest?version=v1']

// Authorization scopes required by the API; multiple scopes can be
// included, separated by spaces.
var SCOPES = 'https://www.googleapis.com/auth/documents'

const SITE = 'Site'
const PRESCRIBER = 'Prescriber'

export default class ClaimSearchView extends React.Component {
  static propTypes = {
    sites: PROPTYPES.sites,
    prescribers: PROPTYPES.prescribers,
    getClaimsJobs: PropTypes.func,
  }

  static defaultProps = {
    isFetchingSites: false,
    isFetchingPrescribers: false,
    sites: [],
    prescribers: [],
    getClaimsJobs: _.noop
  }

  constructor (props) {
    super(props)
    this.state = {
      [`selected${SITE}`]: null,
      [`input${SITE}`]: '',
      devicesComplete: false,
      startDate: new Date(),
      endDate: new Date(),
      patients: [],
      documentId: null,
      claim_created: false,
      isLoadingClaim: false
    }

    this.initClient = this.initClient.bind(this)

    gapi.load('client:auth2', this.initClient)
  }

  // check to see if requirements are met before enabling user to take action, true if prereqs met
  checkPrereqs = (resourceType) => {
    const {
      selectedSite,
    } = this.state

    if (resourceType === SITE) {
      if (selectedSite) {
        return true
      }
    }
    return false
  }

  handleSelectSite = (selected) => {
    if (selected == null) {
      selected = ''
    }
    this.setState({ selectedSite: selected })
  }

  handleSelectPrescriber = (selected) => {
    if (selected == null) {
      selected = ''
    }
    this.setState({ selectedPrescriber: selected })
  }

  handleStartDateSelect = (selected) => {
    this.setState({ startDate: selected})
  }

  handleEndDateSelect = (selected) => {
    this.setState({ endDate: selected})
  }

  handleInput = (resourceType, input) => {
    this.setState({ [`input${resourceType}`]: input })
    return input
  }

  initClient = () => {
    gapi.client.init({
      clientSecret: API_KEY,
      clientId: CLIENT_ID,
      discoveryDocs: DISCOVERY_DOCS,
      scope: SCOPES
    })
  }

  updateTable = () => {
    this.setState({ isLoadingClaim: true })

    var newEnd = new Date(this.state.endDate.getTime())
    newEnd.setDate(newEnd.getDate() + 1)

    this.props.getClaimsJobs(this.state.selectedSite.id, this.state.startDate.getTime(), newEnd.getTime()).then((response) => {
      var patients = response.data
      this.setState({
        patients:patients,
        claim_created: true,
        isLoadingClaim: false
      })
    })
  }

  handleAuthClick = (event) => {
    function formatDate (d) {
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()

      if (month.length < 2) {
        month = '0' + month
      }

      if (day.length < 2) {
        day = '0' + day
      }

      return [month, day, year].join('/')
    }

    gapi.auth2.getAuthInstance().signIn().then(() => {
      const {
        selectedSite,
        startDate,
        endDate
      } = this.state

      gapi.client.docs.documents.create({
        title: `${selectedSite.name} ${formatDate(startDate)}-${formatDate(endDate)}`
      }).then((response) => {
        console.log(response)
        var documentId = response.result.documentId

        this.setState({ documentId: documentId })

        var win = window.open(`https://docs.google.com/document/d/${documentId}/edit`, '_blank')
        if (win) {
          // Browser has allowed it to be opened
          win.focus()
        } else {
          // Browser has blocked it
          alert('Please allow popups for this website')
        }
      })
    })
  }

  handleSignoutClick = (event) => {
    gapi.auth2.getAuthInstance().signOut()
  }

  checkCreateDoc = () => {
    const {
      selectedSite,
      startDate,
      endDate
    } = this.state

    if (selectedSite && startDate && endDate) {
      return true
    }

    return false
  }

  render () {
    const {
      sites,
      prescribers,
      isFetchingSites,
      isFetchingPrescribers
    } = this.props
    const {
      selectedSite,
      patients,
      selectedPrescriber
    } = this.state

    const tRows = _.map(patients, (patient) => {
      const jobInfo = patient.jobs.map((j) => {
        return (
          <li key={j.id}>
            Job Id: {j.id}
            <ul>
              <li>Status: {j.status}</li>
              <li>Date: {moment(j.date).format('MM/DD/YYYY HH:mm a')}</li>
              <li>WBC: {j.wbc_count}</li>
              <li>ANC: {j.anc}</li>
              <li>Neutrophil %: {j.neutrophils}</li>
            </ul>
          </li>
        )
      })

      return (
        <tr key={patient.first_name + ' ' + patient.last_name}>
          <td>
            {patient.first_name} {patient.last_name}
            <br />
            {patient.date_of_birth}
            <br />
            {patient.chronic_conditions ? (
              <div>
                Chronic Conditions:
                <br />
                {patient.chronic_conditions}
                <br />
                {patient.chronic_conditions_other}
              </div>
            ) : null}
          </td>
          <td>
            <ul>
              <li>{patient.insurance_company}:</li>
              <li>Policy Number: {patient.policy_number}</li>
              <li>Medicare: {patient.medicare_id}</li>
              <li>Medicaid: {patient.medicaid_id}</li>  
            </ul>
          </td>
          <td>{patient.num_jobs}</td>
          <td><ul>{jobInfo}</ul></td>
        </tr>
      )
    })

    return (
      <div className='step-form'>
        <div>

          <Step
            title='Site'
          >
            <div>
              <div>Name</div>
              <Select
                isSearchable
                isClearable
                isLoading={isFetchingSites}
                options={sites}
                value={selectedSite}
                onChange={(selected) => this.handleSelectSite(selected)}
                onInputChange={(input) => this.handleInput(SITE, input)}
                onBlurResetsInput={false}
                onCloseResetsInput={false}
                noResultsText={false}
                labelKey={'name'}
                valueKey={'id'}
              />

              <br />
              <div>Period Start Date</div>
              <DatePicker
                selected={this.state.startDate}
                onSelect={this.handleStartDateSelect}
              />

              <br />
              <div>Period End Date</div>
              <DatePicker
                selected={this.state.endDate}
                onSelect={this.handleEndDateSelect}
              />

              <br />
              <br />

              <div>Prescriber</div>
              <Select
                isSearchable
                isClearable
                isLoading={isFetchingPrescribers}
                options={prescribers}
                value={selectedPrescriber}
                onChange={(selected) => this.handleSelectPrescriber(selected)}
                onInputChange={(input) => this.handleInput(PRESCRIBER, input)}
                onBlurResetsInput={false}
                onCloseResetsInput={false}
                noResultsText={false}
                labelKey={'name'}
                valueKey={'id'}
              />

              <br />

              <div className='button-container'>
                <button
                  className='btn btn-primary action-button'
                  onClick={() => { this.updateTable() }}
                  disabled={!this.checkPrereqs(SITE)}
                >
                  Create Claim
                </button>
              </div>
            </div>
          </Step>

          { this.state.isLoadingClaim ? (
            <Step style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
              <BeatLoader loading color={'#fff'} />
            </Step>
          ) : null}

          { this.state.claim_created ? (
            <Step
              title='Copy from here'>
              <div>
                <table className='table' id='claims-table'>
                  <thead className='thead-dark'>
                    <tr>
                      <th scope='col'>Patient</th>
                      <th scope='col'>Insurance</th>
                      <th scope='col'>Number of Tests</th>
                      <th scope='col'>Summary</th>
                    </tr>
                  </thead>

                  <tbody>
                    {tRows}
                  </tbody>
                </table>

                <button
                  className='btn btn-primary action-button'
                  onClick={() => { this.handleAuthClick() }}
                  disabled={!this.checkCreateDoc()}
                >
                  Create Document
                </button>

                <br />

                {this.state.documentId ? (
                  <a href={`https://docs.google.com/document/d/${this.state.documentId}/edit`}> Link to Document </a>
                ) : null}
              </div>
            </Step>
          ) : null}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Claims/components/ClaimSearchView.jsx